module.exports = __webpack_public_path__ + "static/media/insta.ce22b7a9.png";